<template>
  <div>
    <b-container style="margin-top:20px">
      <b-row>
        <b-col>
          <b-form @submit="onSubmit" @reset="onReset">
            <b-form-group
              id="NameGroup"
              label="RBP's Name or Ensmbel ID:"
              label-for="Name"
              description="The name or Ensmbel ID of RNA Binding Protein. eg: 'MKRN3' or 'ENSG00000179455'."
            >
              <SearchInput v-model="form.rbp"></SearchInput>
            </b-form-group>

            <b-form-group id="TumorSiteGroup" label="Tumor Site:" label-for="TumorSite">
              <b-form-select
                id="TumorSite"
                :options="form.tumorSite"
                required
                v-model="form.tumorSiteSelected"
              ></b-form-select>
            </b-form-group>

            <b-form-group id="typeGroup">
              <b-form-checkbox
                v-for="item in form.builder"
                :key="item.name"
                v-model="item.isUsed"
              >{{item.name}}</b-form-checkbox>
            </b-form-group>
            <!--{{form}}-->
            <transition name="fade">
              <b-tabs v-if="showTab">
                <b-tab
                  v-for="(item) in form.builder.filter(d=>d.isUsed)"
                  :key="item.name"
                  :title="item.name"
                >
                  <div>
                    <b-input-group
                      class="pt-3"
                      v-for="(filter,obj) in item.filters"
                      :key="obj"
                      v-b-tooltip.hover
                      :title="filter.desc"
                    >
                      <b-input-group-prepend is-text>
                        <input type="checkbox" v-model="filter.isUsed">
                      </b-input-group-prepend>
                      <b-input-group-prepend is-text>{{ filter.label }}</b-input-group-prepend>
                      <b-form-input v-model="filter.value" type="number" step=0.01></b-form-input>
                    </b-input-group>
                  </div>
                </b-tab>
              </b-tabs>
            </transition>
            <div class="mt-1">
              <b-button type="submit" variant="primary">Submit</b-button>
              <b-button type="reset" variant="danger">Reset</b-button>
            </div>
          </b-form>
          <div class="air-wall"></div>
          <div>
            <transition name="fade">
              <searchResults v-if="res!==null" :result="res" :selected="typeSelected"></searchResults>
            </transition>
          </div>
        </b-col>
        <!--<div>{{res}}</div>-->
      </b-row>
    </b-container>
  </div>
</template>F

<script>
import searchResults from './searchResult'
import SearchInput from './SearchInput'
import Tabtest from './tebtest'

function getData (d) {
  function getFilter (e) {
    let g = {}
    // console.log(e)
    e = e.filter(f => f.isUsed)
    for (let item in e) {
      g[e[item].name] = e[item].value
    }
    return g
  }

  function getFilters (e) {
    let g = {}
    e = e.filter(f => f.isUsed)
    for (let item in e) {
      // console.log(e[item])
      g[e[item].id] = getFilter(e[item].filters)
    }
    return g
  }

  let data = {
    rbp: d.rbp || 0,
    tumorsite: d.tumorSiteSelected,
    type: d.builder.filter(e => e.isUsed).map(e => e.id),
    // filters: d.builder.filter(e => e.isUsed).map(e => {
    //   let f = {}
    //   f[e.id] = e.filters.filter(f => f.isUsed).map(f => {
    //     let g = {}
    //     g[f.name] = f.value
    //     return g
    //   })
    //   return f
    // })
    filters: getFilters(d.builder)
  }
  // console.log(data)
  return data
}

export default {
  components: {
    searchResults,
    SearchInput,
    Tabtest
  },
  name: 'Search',
  data: function () {
    return {
      form: {
        rbp: '',
        tumorSiteSelected: null,
        type: true,
        type2: [],
        method: 'search',
        builder: [
          {
            isUsed: true,
            name: 'Differential Expression',
            id: 'de',
            filters: [
              {
                name: 'pvalue',
                label: 'p-value',
                value: 0.05,
                isUsed: true,
                desc: 'the threshold value of p-value'
              },
              {
                name: 'padj',
                label: 'p-adj',
                value: 0.05,
                isUsed: true,
                desc: 'the threshold value of p-adj(FDR)'
              },
              {
                name: 'log2FoldChange',
                label: 'log2FC',
                value: 1,
                isUsed: true,
                desc: 'log2FoldChange',
                s: true
              }
            ],
            popoverShow: false
          }, {
            isUsed: false,
            name: 'copy number variations',
            id: 'gis',
            filters: [
              {
                name: 'pvalue',
                label: 'p-value',
                value: 0.05,
                isUsed: true,
                desc: 'the threshold value of p-value'
              }
            ]
          },
          {
            isUsed: false,
            name: 'Survival Analysis',
            id: 'sur',
            filters: [
              {
                name: 'pvalue',
                label: 'p-value',
                value: 0.05,
                isUsed: true,
                desc: 'the threshold value of p-value'
              }],
            popoverShow: false
          }],
        tumorSite:
          [
            { text: 'Select One', value: null },
            'Adrenal Gland',
            'Bile Duct',
            'Bladder',
            'Blood'
          ],
        show: true,
        res: null
      },
      res: null
    }
  },
  computed: {
    showTab: vm => vm.form.rbp.length === 0,
    typeSelected: function () {
      // console.log(this.form.builder.filter(a => a.isUsed === true).map(a => a.id))
      return this.form.builder.filter(a => a.isUsed === true).map(a => a.id)
    }
  },
  methods:
    {
      onSubmit (evt) {
        evt.preventDefault()
        this.axios({
          method: 'post',
          url: '/search.php',
          data: getData(this.form)
        }).then(res => {
          this.res = res.data
        })
      },
      onReset (evt) {
        evt.preventDefault()
        this.form.rbp = ''
        this.res = null
        this.form.tumorSite = null
        this.form.type = []
      }
    },
  created () {
    this.axios({
      method: 'post',
      url: '/search.php',
      data: {
        'type': ['tumorSite'],
        rbp: 0
      }
    }).then((res) => {
      this.form.tumorSite = [{
        text: 'Select One',
        value: null
      }].concat(res.data['tumorSite'].map(b => b.tumorsite))
    })
  }
}
</script>

<style scoped>
.air-wall {
  height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue